import { Button } from "antd-mobile";
import { GET, errorCatch, useAuth, useTranslateContext } from "fennec-ui";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { MaxIcon } from "../../../components/Tool";


export default function Max(props) {
    const [searchParams, setSearchParams] = useSearchParams();
    const token = searchParams.get("token");
    const auth = useAuth();

    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [acceptLoading, setAcceptLoading] = useState(false);

    const [user, setUser] = useState();

    useEffect(() => {
        GET(auth, '/api/iam', ({ data }) => setUser(data), errorCatch);

        if (token) {
            GET(auth, `/api/max/by-token?token=${token}`, ({ data, maxData }) => {
                setData({
                    userInfo: data,
                    maxData
                })
            }, errorCatch)
        }
    }, [token])

    useEffect(() => {
        if (data && user) {
            setLoading(false)
        }
    }, [data, user])

    const accept = () => {
        if (token) {
            setAcceptLoading(true);
            GET(auth, `/api/max/link?token=${token}`, ({ data, maxData }) => {
                setData({
                    userInfo: data,
                    maxData
                })
                setAcceptLoading(false)
            }, (err) => errorCatch(err, () => setAcceptLoading(false)))
        }
    }
    const unlink = () => {
        GET(auth, `/api/max/unlink`, ({ data }) => {

        }, errorCatch)
    }
    const cancel = () => {
        window.location.href = "/"
    }
    return (

        <div className={(loading) ? "" : "loaded"}>
            <div className="preloader">
                <div className="preloader__row">
                    <div className="preloader__item blue"></div>
                    <div className="preloader__item red"></div>
                </div>
            </div>
            <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                {(data && user) && <div style={{padding:"0px 5px"}}>
                    {(data?.userInfo && data?.userInfo.ID > 0 && user && data?.userInfo.ID === user.ID) && <div>
                        <div style={{ fontSize: "20px", fontWeight: "600", textAlign: "center", paddingBottom: "20px" }}>
                            Ваш аккаунт <br /> связан с Max!
                        </div>
                        <div style={{ display: "flex", gap: "20px", alignItems: "center", flexDirection:"column" }}>
                            {(data?.userInfo) && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <div><img src='/resources/logo.png'></img></div>
                                <div>
                                    <div>{data?.userInfo.lastname} {data?.userInfo.firstname}</div>
                                    <div>{data?.userInfo.email}</div>
                                </div>
                            </div>}
                            <div>
                                <i className="fa fa-arrows-v" style={{ fontSize: "40px", color: "#afafaf" }}></i>
                            </div>
                            {(data && data.maxData && data.maxData.From) && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <div><MaxIcon width={40} height={40} color="#4096ff" /></div>
                                <div>
                                    {(data.maxData.From.last_name && data.maxData.From.first_name) && <div>{data.maxData.From.last_name} {data.maxData.From.first_name}</div>}
                                    {(data.maxData.From.username) && <div>@{data.maxData.From.username}</div>}
                                </div>
                            </div>}
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", gap: "15px", paddingTop: "20px" }}>
                            <Button disabled={acceptLoading} style={{ flex: "1 1 auto" }} color='primary' fill='none' onClick={cancel}>На главную</Button>
                        </div>
                    </div>}
                    {(data?.userInfo && data?.userInfo.ID > 0 && user && data?.userInfo.ID !== user.ID) && <div>
                        <div style={{paddingBottom:"25px"}}>
                            <div style={{ fontSize: "20px", fontWeight: "600", textAlign: "center", paddingBottom: "20px" }}>
                                Этот Max-чат <br /> связан с другим аккаунтом!
                            </div>
                            <div style={{ display: "flex", gap: "20px", alignItems: "center", flexDirection:"column" }}>
                                {(data?.userInfo) && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <div><img src='/resources/logo.png'></img></div>
                                    <div>
                                        <div>{data?.userInfo.lastname} {data?.userInfo.firstname}</div>
                                        <div>{data?.userInfo.email}</div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                        <div>
                            <div style={{ fontSize: "20px", fontWeight: "600", textAlign: "center", paddingBottom: "20px" }}>
                                Вы хотите связать <br />свой аккаунт и Max?
                            </div>
                            <div style={{ display: "flex", gap: "20px", alignItems: "center", flexDirection:"column" }}>
                                {(user) && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <div><img src='/resources/logo.png'></img></div>
                                    <div>
                                        <div>{user.lastname} {user.firstname}</div>
                                        <div>{user.email}</div>
                                    </div>
                                </div>}
                                <div>
                                    <i className="fa fa-arrows-v" style={{ fontSize: "40px", color: "#afafaf" }}></i>
                                </div>
                                {(data && data.maxData && data.maxData.From) && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <div><MaxIcon width={40} height={40} color="#4096ff" /></div>
                                    <div>
                                        {(data.maxData.From.last_name && data.maxData.From.first_name) && <div>{data.maxData.From.last_name} {data.maxData.From.first_name}</div>}
                                        {(data.maxData.From.username) && <div>@{data.maxData.From.username}</div>}
                                    </div>
                                </div>}
                            </div>
                            <div style={{ display: "flex", justifyContent: "center", gap: "15px", paddingTop: "20px" }}>
                                <Button disabled={acceptLoading} style={{ flex: "1 1 auto" }} onClick={cancel}>Отмена</Button>
                                <Button loading={acceptLoading} style={{ flex: "1 1 auto" }} color='primary' fill='solid' onClick={accept}>Связать</Button>
                            </div>
                        </div>
                    </div>}
                    {(!data?.userInfo || data?.userInfo.ID === 0) && <div>
                        <div style={{ fontSize: "20px", fontWeight: "600", textAlign: "center", paddingBottom: "20px" }}>
                            Вы хотите связать <br />свой аккаунт и Max?
                        </div>
                        <div style={{ display: "flex", gap: "20px", alignItems: "center", flexDirection:"column" }}>
                            {(user) && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <div><img src='/resources/logo.png'></img></div>
                                <div>
                                    <div>{user.lastname} {user.firstname}</div>
                                    <div>{user.email}</div>
                                </div>
                            </div>}
                            <div>
                                <i className="fa fa-arrows-v" style={{ fontSize: "40px", color: "#afafaf" }}></i>
                            </div>
                            {(data && data.maxData && data.maxData.From) && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <div><MaxIcon width={40} height={40} color="#4096ff" /></div>
                                <div>
                                    {(data.maxData.From.last_name && data.maxData.From.first_name) && <div>{data.maxData.From.last_name} {data.maxData.From.first_name}</div>}
                                    {(data.maxData.From.username) && <div>@{data.maxData.From.username}</div>}
                                </div>
                            </div>}
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", gap: "15px", paddingTop: "20px" }}>
                            <Button disabled={acceptLoading} style={{ flex: "1 1 auto" }} onClick={cancel}>Отмена</Button>
                            <Button loading={acceptLoading} style={{ flex: "1 1 auto" }} color='primary' fill='solid' onClick={accept}>Связать</Button>
                        </div>
                    </div>}
                </div>}
            </div>
        </div>
    );
}

